var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clientData.switchOffTimesActive)?_c('div',[_c('switch-off-times',{staticClass:"pa-4 pt-0",attrs:{"data":_vm.clientData.switchOffTimes,"enableConfiguredByProject":"","popupUsedInModal":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1):_c('div',[_vm._v("\n    "+_vm._s(_vm.switchOffTimesDisabled)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }